import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Form,
  Table,
  Typography,
  Select,
  Button,
  Upload,
  message,
  Tag,
  Input,
  Popover,
  Popconfirm,
  Space,
  Card,
} from "antd";
import {
  getFirestore,
  serverTimestamp,
  doc,
  setDoc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";
import  {getAuth} from "firebase/auth";
import HighLighter from "react-highlight-words";
import { ref, uploadBytes, getDownloadURL, getStorage } from "firebase/storage";
import { EditOutlined, UploadOutlined, SearchOutlined } from "@ant-design/icons";
import { ItemsView } from "../../../Orders/ItemsView";
import { Gallery } from "../../../Orders/Gallery";
import { formatTimestamp, statusList,reasonsList,decrypt,collections,fetchData } from "../../../../utils";
import { checkAccess } from "../../../../access";
import { logUserAction } from "../../../../logs";
import { OrdersContext } from "../../../../context/OrdersContext";

const { Option } = Select;
const { TextArea } = Input;

const validStatuses = ["Entregado"];



export const DeliveredNotCollected = ({ data }) => {

  const { refetch: refetchOrders } = useContext(OrdersContext);
  const [dataNew, setDataNew] = useState([]);
  const [form] = Form.useForm();
  const [couriers, setCouriers] = useState();
  const [payments, setPayments] = useState();
  const [role,setRole] = useState();
  const [openPay,setOpenPay] = useState(false);
  const [openCancel,setOpenCancel] = useState(false);
  const [confirmVisible,setConfirmVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  // open detail
  const [openDetail, setOpenDetail] = useState(false);
  // open receipt
  const [openReceipt, setOpenReceipt] = useState(false);
  // set detail data
  const [detail, setDetail] = useState([]);
  // set order
  const [order] = useState();
  // set receipts
  const [receipts, setReceipts] = useState();
  // set closing channels
  const [salesclosingchannel, setSalesclosingchannel] = useState();
  // set channels
  const [channels,setChannels] = useState();
  // set brands
  const [brands,setBrands] = useState();
  // set categories
  const [categories,setCategories] = useState();
  const [sizeWindow, setSizeWindow] = useState(window.innerWidth > 768);
  const [search, setSearch] = useState("");
  const [searchedCol, setSearchedCol] = useState("");


  const querydb = getFirestore();
  const auth = getAuth();

  const searchInput = useRef(null); 


  // handle payment
  const payingDebt = async (record) => {
    setConfirmLoading(true);

    form.setFieldsValue({
      payable: Number(0.00),
      payment: "RECAUDADO",
    });

    const newData = [...data];

    const index = newData.findIndex((item) => record.key === item.key);
    console.log("Found index:", index);

    if (index > -1){
      const item = newData[index];
      console.log("Found item:", item);
      newData.splice(index,1,{
        ...item,
        payable:0,
      });
      setDataNew(newData);
    }

    await updateDoc(doc(querydb, "orders", record.key),{
      payable:0,
      payment:"RECAUDADO",
    });

    refetchOrders();

    message.success(`Pedido ${record.serial} saldo por pagar $0.00`);
    logUserAction(querydb,auth,"PAY_ORDER",record.serial);
    setConfirmVisible(false);
    setConfirmLoading(false);
  }

  // handle cancel
  const cancelOrder = async (record) => {
    setConfirmLoading(true);
    form.setFieldsValue({
      status:"Cancelado"
    });

    refetchOrders();
    message.success(`Pedido ${record.serial} cancelado`);
    setConfirmVisible(false);
    setConfirmLoading(false);
    setOpenCancel(false);
  }

  // handle reason
  const handleReason = (value) => {
    form.setFieldsValue({
      cancelReason:value
    })
  }

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  // hide payment panel
  const hidePay = () => {
    setOpenPay(false);
  }

  // hide cancel panel
  const hideCancel = () => {
    setOpenCancel(false);
  }

  // open payment panel
  const handleOpenPay = (newOpen) => {
    setOpenPay(newOpen);
  }

  // open cancel panel
  const handleOpenCancel = (newOpen) => {
    setOpenCancel(newOpen);
  }

  // Editable cell component
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const uploadFile = async (file) => {
      const storage = getStorage();
      const fileRef = ref(storage, file.name);
      await uploadBytes(fileRef, file);

      const downloadUrl = await getDownloadURL(fileRef);

      form.setFieldsValue({ fileImage: downloadUrl });
    };

    // handle payment select
    const handlePaymentMethod = (value) => {
      form.setFieldsValue({paymenttype:value});
    }

    // pay panel
    const payPanel = (record) => (
      <>
        <p>Selecciona el metodo de pago</p>
        <br/>
        <Select defaultValue={record.paymenttype} onSelect={handlePaymentMethod}>
                  {payments && payments.length
                    ? payments.map((method, i) => (
                        <Option key={i} value={method.name}>
                          {method.name}
                        </Option>
                      ))
                    : null}
        </Select>
        <br/><br/>
        <Popconfirm
        title="Marcar pedido como pagado?"
        okText="Si"
        cancelText="No"
        open={confirmVisible}
        onConfirm={() => payingDebt(record)}
        onCancel={handleCancel}
        okButtonProps={{
          loading:confirmLoading,
        }}
        >
          <Button type="primary" onClick={() => setConfirmVisible(true)}>Pagar</Button>
        </Popconfirm>
        <br/><br/>
        <Typography.Link onClick={hidePay}>Cerrar</Typography.Link>
      </>
    );

    const cancelPanel = (record) => (
      <>
        <p>Selecciona razon de cancelacion</p>
        <br/>
        <Select default={record.cancelReason || reasonsList.unknown} onSelect={handleReason}>
            {Object.values(reasonsList).map((reason,index) => 
            <Option value={reason} key={index}>{reason}</Option>)}
        </Select>
        <br/><br/>
        <Popconfirm
        title="Marcar pedido como cancelado?"
        okText="Si"
        cancelText="No"
        open={confirmVisible}
        onConfirm={() => cancelOrder(record)}
        onCancel={handleCancel}
        okButtonProps={{
          loading:confirmLoading,
        }}
        >
          <Button type="primary" onClick={() => setConfirmVisible(true)}>Confirmar</Button>
        </Popconfirm>
        <br/><br/>
        <Typography.Link onClick={hideCancel}>Cerrar</Typography.Link>
      </>
    );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            form={form}
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required:false,
                message: `Ingresar valor de ${title}!`,
              },
            ]}
          >
            {dataIndex === "paymenttype" ? (
              <Select defaultValue={record.paymenttype}>
                {payments && payments.length
                  ? payments.map((method, i) => (
                      <Option key={i} value={method.name}>
                        {method.name}
                      </Option>
                    ))
                  : null}
              </Select>
            ) : dataIndex === "status" ? (
              <Select defaultValue={record.status}>
                {Object.keys(statusList).map((status, i) => (
                  <Option key={i} value={status}>
                    {status}
                  </Option>
                ))}
              </Select>
            ) : dataIndex === "courier" ? (
              <Select defaultValue={record.courier}>
                {couriers && couriers.length
                  ? couriers.map((courier, i) => (
                      <Option key={i} value={courier.name}>
                        {courier.name}
                      </Option>
                    ))
                  : null}
              </Select>
            ) : dataIndex === "fileImage" ? (
              <>
                <Upload
                  accept=".png,.jpg,.jpeg"
                  onChange={(info) => {
                    if (info.file.status !== "uploading") {
                      console.log(info.file, info.fileList);
                    }
                    if (info.file.status === "done") {
                      message.success(
                        `${info.file.name} fue subido exitosamente`
                      );
                    } else if (info.file.status === "error") {
                      message.error(`${info.file.name} no pudo subirse.`);
                    }
                  }}
                  customRequest={async ({ file, onSuccess }) => {
                    await uploadFile(file);
                    onSuccess({ status: "done" });
                  }}
                >
                  <Button icon={<UploadOutlined />}>Subir</Button>
                </Upload>
              </>
            ) : dataIndex === "comments" ? (
              <TextArea rows={5} placeholder="observaciones del pedido" defaultValue={record.comments}/>
            ) : dataIndex === "payment" ? <Select defaultValue={record.payment}>
            <Option value="POR RECAUDAR">Por Recaudar</Option>
            <Option value="RECAUDADO">Recaudado</Option>
            <Option value="PERDIDA">Perdida</Option>
          </Select> : (dataIndex === "payable" && (form.getFieldValue("paymenttype") === "CONTRAENTREGA")) 
          || (dataIndex === "payable" && (form.getFieldValue("payable") > 0)) ? <>
              <Popover
              content={payPanel(record)}
              title="Pago de pedido"
              trigger="click"
              open={openPay}
              onOpenChange={handleOpenPay}
              >
                <Typography.Link>Pagar</Typography.Link>
              </Popover>
          </> : dataIndex === "cancelReason" ? 
          <Popover
          content={cancelPanel(record)}
          title="Cancelacion de Pedido"
          trigger="click"
          open={openCancel}
          onOpenChange={handleOpenCancel}
          >
            <Typography.Link>Cancelar Pedido</Typography.Link>
          </Popover> : dataIndex === "channel" ? <Select defaultValue={record.channel}>
            {channels && channels.length ? channels.map((channel,i) => (
              <Option key={i} value={channel.name}>{channel.name}</Option>
            )) : null}
          </Select> : (
              <p>configure el elemento de edicion</p>
            )}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };


  const getProducts = async (order) => {
    setDetail(order.products);
  };



  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    console.log("Editing record:", record);
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
    form.resetFields();
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataNew];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];

        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        console.log(newData[index]);

        setDataNew(newData);
        setEditingKey("");
        await setDoc(doc(querydb, "orders", item.key), {
          ...item,
          ...row,
          comments: row.comments
            ? row.comments.toUpperCase()
            : item.comments
            ? item.comments.toUpperCase()
            : null,
          courier: row.courier
            ? row.courier.toUpperCase()
            : item.courier
            ? item.courier.toUpperCase()
            : null,
          paymenttype: row.paymenttype
            ? row.paymenttype.toUpperCase()
            : item.paymenttype
            ? item.paymenttype.toUpperCase()
            : null,
          status: row.status
            ? row.status
            : item.status
            ? item.status
            : "Pendiente",
          payable: typeof row.payable !== "undefined" ? row.payable : item.payable,
          payment: row.payment 
            ? row.payment 
            : item.payment 
            ? item.payment 
            : "POR RECAUDAR",
          cancelReason: row.cancelReason 
            ? row.cancelReason.toUpperCase() 
            : row.cancelReason && row.status === "Cancelado" 
            ? "SIN SELECCIONAR" 
            : "NO APLICA",
          dateEnd: serverTimestamp(),
        });

        if(row.fileImage && row.fileImage.length > item.fileImage.length){
          await updateDoc(doc(querydb, "orders", item.key), {
            fileImage: arrayUnion(...item.fileImage,row.fileImage),
          });
        }

        if(row.status !== item.status){
          logUserAction(querydb,auth,"EDIT_STATUS",item.serial,row.status);
        }

        logUserAction(querydb,auth,"EDIT_ORDER",item.serial,"",{
          ...item,
          ...row,
          comments: row.comments
            ? row.comments.toUpperCase()
            : item.comments
            ? item.comments.toUpperCase()
            : null,
          courier: row.courier
            ? row.courier.toUpperCase()
            : item.courier
            ? item.courier.toUpperCase()
            : null,
          paymenttype: row.paymenttype
            ? row.paymenttype.toUpperCase()
            : item.paymenttype
            ? item.paymenttype.toUpperCase()
            : null,
          status: row.status
            ? row.status
            : item.status
            ? item.status
            : "Pendiente",
          payable: typeof row.payable !== "undefined" ? row.payable : item.payable,
          payment: row.payment 
            ? row.payment 
            : item.payment 
            ? item.payment 
            : "POR RECAUDAR",
          cancelReason: row.cancelReason 
            ? row.cancelReason.toUpperCase() 
            : row.cancelReason && row.status === "Cancelado" 
            ? "SIN SELECCIONAR" 
            : "NO APLICA",
          dateEnd: serverTimestamp(),
        });
        refetchOrders();
        form.resetFields();
      }
    } catch (errInfo) {
      console.log(errInfo);
    }
  };

  const selectReceipts = async (order) => {
    setReceipts(order.fileImage);
    setOpenReceipt(true);
  };


  const handleReset = (clearFilters) => {
    clearFilters();
    setSearch("");
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearch(selectedKeys[0]);
    setSearchedCol(dataIndex);
  };

  const getColSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar por ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reiniciar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearch(selectedKeys[0]);
              setSearchedCol(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#189Off" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => 
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedCol === dataIndex ? (
        <HighLighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[search]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  useEffect(() => {
    setInterval(async() => {
      setRole(await decrypt(localStorage.getItem("role")));
    },1000);
    fetchData(querydb,collections.couriers,setCouriers);
    fetchData(querydb,collections.payment_types,setPayments);
    fetchData(querydb,collections.closing_channels,setSalesclosingchannel);
    fetchData(querydb,collections.brands,setBrands);
    fetchData(querydb,collections.categories,setCategories);
    fetchData(querydb,collections.sale_channels,setChannels);
    const filteredData = data.filter(order => validStatuses.includes(order.status) && order.department === "LIMA" && order.payment === "POR RECAUDAR");
    setDataNew(filteredData);
    window.innerWidth > 1000 ? setSizeWindow(true) : setSizeWindow(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[querydb, data]);


  const columns = [
    {
      title: "Serial",
      dataIndex: "serial",
      key: "serial",
      width: 80,
      fixed: sizeWindow ? "left" : false,
      ...getColSearchProps("serial"),
    },
    {
      title: "Cliente",
      dataIndex: "customerName",
      key:"customerName",
      width: 250,
      ...getColSearchProps("customerName"),
      fixed: sizeWindow ? "left" : false,
    },
    {
      title: "Vendedor",
      dataIndex: "seller",
      key:"seller",
      width: 160,
      ...getColSearchProps("seller"),
    },
    {
      title: "Telefono",
      dataIndex: "phoneNumber",
      key:"phoneNumber",
      width: 130,
      ...getColSearchProps("phoneNumber"),
    },
    {
      title: "Distrito",
      dataIndex: "district",
      key:"district",
      filters:dataNew && dataNew.length ? [...new Map(dataNew.map(item => [item.district,item])).values()].map((order) => {
        return {
          text:order.district,
          value:order.district.toUpperCase()
        }
      }).sort((a,b) => a.text.localeCompare(b.text)) : null,
      onFilter:(value,record) => record.district.toLowerCase() === value.toLowerCase(),
      width: 210,
    },
    {
      title: "Direccion",
      dataIndex: "address",
      key:"address",
      width: 350,
    },
    {
      title: "Courier",
      dataIndex: "courier",
      key:"courier",
      width: 150,
    },
    {
      title: "Tipo de Pago",
      dataIndex: "paymenttype",
      key:"paymenttype",
      editable: (checkAccess("editOrders",role) && form.getFieldValue("payable") > 0) || 
      (checkAccess("editOrders",role) && (form.getFieldValue("paymenttype") === "CONTRAENTREGA")),
      width: 150,
    },
    {
      title: "Canal",
      dataIndex: "channel",
      key:"channel",
      width: 180,
      editable:checkAccess("editSaleChannels",role),
    },
    {
      title: "Canal de Venta",
      dataIndex: "salesclosingchannel",
      key:"salesclosingchannel",
      filters:
        salesclosingchannel && salesclosingchannel.length
          ? salesclosingchannel.map((channel) => {
              return {
                text: channel.name,
                value: channel.name.toUpperCase(),
              };
            })
          : null,
      onFilter: (value, record) =>
        record.salesclosingchannel.toLowerCase() === value.toLowerCase(),
      width: 150,
    },
    {
      title: "Comprobante",
      dataIndex: "fileImage",
      key:"fileImage",
      width: 200,
      editable: true,
      filters:[
        {
          text:"Sin comprobante",
          value:false,
        },
        {
          text:"Con comprobante",
          value:true,
        }
      ],
      onFilter:(value,record) => {
        return Boolean(record.fileImage.length) === value;
      },
      render: (_, record) => {
        return !record.fileImage || !record.fileImage.length ? (
            <p>S/C</p>
        ) : (
          
            <Button type="link" onClick={() => selectReceipts(record)}>
              Visualizar
            </Button>
          
        );
      },
    },
    {
      title:"Pago",
      dataIndex:"payment",
      key:"payment",
      width:150,
      editable:checkAccess("editOrders",role),
    },
    {
      title: "Monto Venta",
      dataIndex: "saleAmount",
      key:"saleAmount",
      width: 130,
      render: (_, record) => {
        return <span>${record.saleAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Monto Envio",
      dataIndex: "shippingAmount",
      key:"shippingAmount",
      width: 130,
      render: (_, record) => {
        return <span>${record.shippingAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago adelantado",
      dataIndex: "advanceDelivery",
      key:"advanceDelivery",
      width: 150,
      render: (_, record) => {
        return <span>${record.advanceDelivery.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago pendiente",
      dataIndex: "payable",
      key:"payable",
      width: 150,
      editable:(checkAccess("editOrders",role) && form.getFieldValue("payable") !== 0) || 
      (checkAccess("editOrders",role) && (form.getFieldValue("paymenttype") === "CONTRAENTREGA")),
      render: (_, record) => {
        return <span>${record.payable.toFixed(2)}</span>;
      },
    },
    {
      title: "Fecha Pedido",
      dataIndex: "dateStart",
      key:"dateStart",
      width: 175,
      render: (_, record) => {
        return (
          <>
            {typeof record.dateStart !== "string" ? (
              <span>{formatTimestamp(record.dateStart, 'hour')}</span>
            ) : null}
          </>
        );
      },
      sorter: (a, b) => b.dateStart.seconds - a.dateStart.seconds,
      defaultSortOrder: 'ascend',
    },
    {
      title: "Fecha Preparacion",
      dataIndex: "dateEnd",
      key:"dateEnd",
      width: 175,
      render: (_, record) => {
        return (
          <>
            {typeof record.dateEnd !== "string" ? (
              <span>{formatTimestamp(record.dateEnd, 'hour')}</span>
            ) : null}
          </>
        );
      },
      sorter: (a, b) => b.dateStart.seconds - a.dateStart.seconds,
      defaultSortOrder: 'ascend',
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      editable: checkAccess("editOrders",role),
      onFilter: (value, record) => record.status === value,
      render: (_, record) => {
          return (
              <>
                  {statusList[record.status] ? (
                      <Tag color={statusList[record.status].color}>{record.status}</Tag>
                  ) : null}
              </>
          );
      },
    },
    {
      title: "Accion",
      dataIndex: "operation",
      key:"operation",
      width: 100,
      fixed: sizeWindow ? "right" : false,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
              }}
              className="text-link"
            >
              Guardar
            </Typography.Link>
            <br />
            <Typography.Link
              onClick={() => cancel()}
              style={{
                marginRight: 8,
              }}
              className="text-link"
            >
              Cancelar
            </Typography.Link>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
            className="text-link"
          >
            <EditOutlined />
          </Typography.Link>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <>
            <Card title={
              <div className="flex justify-between items-center">
                <div>
                  Lista de ordenes entregadas y no recaudadas
                </div>
                <div>
                  {dataNew.length} Ordenes
                </div>
            </div>  
              } >
              <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              dataSource={dataNew}
              columns={mergedColumns}
              rowClassName="editable-row"
              pagination={{
                onChange: cancel,
              }}
              scroll={{
                x: 1300,
                y: 500,
              }}
            />
            </Form>
          </Card>
      <ItemsView
        isModalOpen={openDetail}
        setIsModalOpen={setOpenDetail}
        detail={detail}
        order={order}
        brands={brands}
        categories={categories}
        updateItems={getProducts}
        setDetail={setDetail}
        role={role}
      />
      <Gallery
        images={receipts}
        isModalOpen={openReceipt}
        setIsModalOpen={setOpenReceipt}
      />
    </>
  );
};
